import { personType } from './personType';
import { imageResizerService } from '../../imageResizerService';
import { removeEmptyProperties } from '../../../utils/objectUtils';
import { stripTags } from '../../../utils/stringUtils';

// @see https://schema.org/ImageObject
export const imageObjectType = imageEntity => {
  if (!imageResizerService.isValidEntity(imageEntity)) {
    return null;
  }

  const styledImageObject = imageResizerService.getResizedImage(
    imageEntity.mediaImage,
    1900,
    {
      position: imageEntity.focalPoint,
      quality: imageResizerService.getImageEntityQuality(imageEntity.quality)
    }
  );

  const caption = imageEntity.caption || imageEntity.mediaImage?.alt;
  const alternateName = imageEntity.mediaImage?.url
    ? imageEntity.mediaImage.url
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    : null;

  return removeEmptyProperties({
    '@type': 'ImageObject',
    url: styledImageObject.url,
    width: styledImageObject.width,
    height: styledImageObject.height,
    author: personType(imageEntity.contributor), // https://schema.org/author (The author of this content)
    contributor: personType(imageEntity.credit), // https://schema.org/contributor (A secondary contributor to the CreativeWork)
    caption: stripTags(caption),
    name: imageEntity.entityLabel,
    alternateName
  });
};
